module.exports = __webpack_public_path__ + "static/media/check.c8be9ff4.svg";